import { Link } from "react-router-dom";
import { Star, Quote } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { TESTIMONIALS } from "../data/site";

export const Testimonials = () => (
    <section className="py-16 lg:py-24 bg-bone" data-testid="section-testimonials">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <SectionHead eyebrow="Client Voices" title="Rated 4.8/5 by 127 Verified Buyers" center as="h3" />
            <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {TESTIMONIALS.map((t, i) => (
                    <Reveal key={t.name} delay={i * 0.08}>
                        <figure className="bg-white rounded-lg border border-slate-200 p-6 h-full flex flex-col hover:shadow-lg hover:border-gold/50 transition-all" data-testid={`testimonial-${i}`}>
                            <Quote className="w-6 h-6 text-gold/50" />
                            <blockquote className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{t.text}</blockquote>
                            <figcaption className="mt-5 pt-4 border-t border-slate-100">
                                <div className="flex gap-0.5" aria-label={`${t.rating} out of 5 stars`}>
                                    {[1, 2, 3, 4, 5].map((s) => (
                                        <Star key={s} className={`w-3.5 h-3.5 ${s <= Math.round(t.rating) ? "text-gold fill-gold" : "text-slate-200"}`} />
                                    ))}
                                </div>
                                <p className="mt-2 text-sm font-bold text-navy">{t.name}</p>
                                <p className="text-[11px] font-mono uppercase tracking-wider text-slate-400">{t.location}</p>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export const ExploreLinks = () => (
    <section className="py-12 bg-white border-t border-slate-100" data-testid="explore-links">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
            <p className="text-base sm:text-lg text-slate-600 leading-relaxed">
                New to the corridor? Start with{" "}
                <Link to="/yeida-authority-plots/" className="text-gold-deep font-semibold hover:underline">YEIDA Authority plots</Link>{" "}
                or{" "}
                <Link to="/kisan-kota-plots/" className="text-gold-deep font-semibold hover:underline">semi commercial (7% Kisan Kota) plots</Link>,
                compare{" "}
                <Link to="/sectors/" className="text-gold-deep font-semibold hover:underline">YEIDA sectors</Link>,
                browse{" "}
                <Link to="/listings/" className="text-gold-deep font-semibold hover:underline">current listings</Link>,
                read the{" "}
                <Link to="/development/" className="text-gold-deep font-semibold hover:underline">full development guide</Link>{" "}
                and download the{" "}
                <Link to="/investor-guide/" className="text-gold-deep font-semibold hover:underline">free Investor Guide</Link>.
            </p>
            <p className="mt-6 text-sm text-slate-500 leading-relaxed">
                Investing from Delhi, Noida, Ghaziabad or Gurugram? OM Infra covers the complete Yamuna Expressway
                real estate market — residential plots in Greater Noida and Noida Extension, land near Jewar Airport,
                YEIDA plot resale, plots near Pari Chowk, Film City and the Medical Device Park, farmer quota and
                authority plots across Gautam Buddha Nagar. YEIDA and RERA-approved inventory with clean connectivity
                to the DND Flyway, Noida-Greater Noida Expressway, Sector 150 and both expressways — with on-ground
                teams at both ends of the corridor.
            </p>
        </div>
    </section>
);
